import { render, staticRenderFns } from "./ExampleGiftList.vue?vue&type=template&id=9fe7b36e&scoped=true"
import script from "./ExampleGiftList.vue?vue&type=script&lang=js"
export * from "./ExampleGiftList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fe7b36e",
  null
  
)

export default component.exports